import { 
    REFERRAL_FORM_GET_REQUEST, REFERRAL_FORM_GET_SUCCESS, REFERRAL_FORM_GET_ERROR, 
    REFERRAL_FORM_GET_BY_KEY_REQUEST, REFERRAL_FORM_GET_BY_KEY_SUCCESS, REFERRAL_FORM_GET_BY_KEY_ERROR, 
    REFERRAL_FORM_ADD_REQUEST, REFERRAL_FORM_ADD_SUCCESS, REFERRAL_FORM_ADD_ERROR, 
    REFERRAL_FORM_EDIT_REQUEST, REFERRAL_FORM_EDIT_SUCCESS, REFERRAL_FORM_EDIT_ERROR, 
    REFERRAL_FORM_DELETE_REQUEST, REFERRAL_FORM_DELETE_SUCCESS, REFERRAL_FORM_DELETE_ERROR
} from "../constants/referralFormConstants";

const initialState = {
    referralForms: [],
    referralForm: {},
    loading: false,
    success: null,
    error: null,
    referralFormRequestedCount: 0,
};

export const referralFormReducer = (state = initialState, action) => {
    switch (action.type)     {
        case REFERRAL_FORM_GET_REQUEST:
            return {
                ...state,
                referralFormRequestedCount: ++state.referralFormRequestedCount,
                loading: true,
            };
        case REFERRAL_FORM_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                referralForms: action.payload,
                success: true,
            };
        case REFERRAL_FORM_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REFERRAL_FORM_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REFERRAL_FORM_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                referralForm: action.payload,
                success: true,
            };
        case REFERRAL_FORM_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REFERRAL_FORM_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REFERRAL_FORM_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REFERRAL_FORM_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REFERRAL_FORM_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REFERRAL_FORM_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REFERRAL_FORM_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REFERRAL_FORM_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REFERRAL_FORM_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REFERRAL_FORM_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
